import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { IntroBannerComponent } from './components/intro-banner/intro-banner.component';
import { HomeComponent } from './home.component';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { CoreModule } from 'src/app/core/core.module';
import { ReassuranceComponent } from './components/reassurance/reassurance.component';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from 'src/app/shared/shared.module';
import { LazyLoadDirective } from './lazy-load.directive';
import { TranslateModule } from '@ngx-translate/core';
import { TrustpilotComponent } from './components/trustpilot/trustpilot.component';
import { DemosComponent } from './components/demos/demos.component';
import { SpeedComponent } from './components/speed/speed.component';
import { SeoComponent } from './components/seo/seo.component';
import { ComparaisonComponent } from './components/comparaison/comparaison.component';
import { ConversionComponent } from './components/conversion/conversion.component';
import { UpsellComponent } from './components/upsell/upsell.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { CustomerServiceComponent } from './components/customer-service/customer-service.component';
import { ProductsHomeComponent } from './components/products-home/products-home.component';
import { SocialsComponent } from './components/socials/socials.component';
import { SkeletonModule } from 'primeng/skeleton';
import { ShopifyAffiliationComponent } from './components/shopify-affiliation/shopify-affiliation.component';

@NgModule({
  declarations: [
    HomeComponent,
    IntroBannerComponent,
    ReassuranceComponent,
    TrustpilotComponent,
    DemosComponent,
    SpeedComponent,
    SeoComponent,
    ComparaisonComponent,
    ConversionComponent,
    UpsellComponent,
    ApplicationsComponent,
    CustomerServiceComponent,
    ProductsHomeComponent,
    SocialsComponent,
    LazyLoadDirective,
    ShopifyAffiliationComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    ButtonModule,
    CoreModule,
    SharedModule,
    SkeletonModule,
    AccordionModule,
    DialogModule,
    TranslateModule.forChild(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HomeModule {}
